import React, { useEffect, useState } from "react";
import { useSearchParams, Link } from "react-router-dom";
import { http, formatApiError } from "@/lib/api";
import { CheckCircle2, XCircle, Loader2 } from "lucide-react";

export default function NewsletterUnsubscribe() {
    const [params] = useSearchParams();
    const token = params.get("token");
    const [status, setStatus] = useState(token ? "loading" : "no-token");
    const [email, setEmail] = useState("");

    useEffect(() => {
        if (!token) return;
        (async () => {
            try {
                const { data } = await http.post(`/newsletter/unsubscribe?token=${encodeURIComponent(token)}`);
                setEmail(data.email || "");
                setStatus(data.ok ? "ok" : "error");
            } catch (e) {
                setStatus("error");
                setEmail(formatApiError(e?.response?.data?.detail) || "");
            }
        })();
    }, [token]);

    return (
        <div className="max-w-2xl mx-auto px-6 py-24 text-center" data-testid="newsletter-unsubscribe-page">
            <p className="text-xs uppercase tracking-[0.35em] text-primary mb-4 font-medium">Newsletter</p>
            {status === "loading" && (
                <>
                    <Loader2 className="w-8 h-8 text-primary mx-auto mb-4 animate-spin" />
                    <h1 className="font-serif text-3xl md:text-4xl">Désinscription en cours…</h1>
                </>
            )}
            {status === "ok" && (
                <>
                    <CheckCircle2 className="w-10 h-10 text-primary mx-auto mb-4" />
                    <h1 className="font-serif text-3xl md:text-4xl mb-4">Vous êtes désinscrit.</h1>
                    <p className="text-foreground/70 leading-relaxed">
                        L'adresse <strong className="font-medium text-foreground/90">{email}</strong> a été retirée de notre liste d'infolettre.
                        Vous ne recevrez plus de nouveaux emails de notre part.
                    </p>
                    <p className="text-sm text-muted-foreground mt-4">
                        Si vous avez changé d'avis, vous pouvez vous réinscrire à tout moment depuis le pied de page.
                    </p>
                </>
            )}
            {(status === "error" || status === "no-token") && (
                <>
                    <XCircle className="w-10 h-10 text-destructive mx-auto mb-4" />
                    <h1 className="font-serif text-3xl md:text-4xl mb-4">Lien invalide</h1>
                    <p className="text-foreground/70 leading-relaxed">
                        Ce lien de désinscription est invalide ou a expiré. Merci d'utiliser le lien présent dans un de nos emails récents.
                    </p>
                </>
            )}
            <div className="mt-10">
                <Link to="/" className="text-sm underline decoration-primary/40 underline-offset-4 hover:decoration-primary">
                    ← Retour à l'accueil
                </Link>
            </div>
        </div>
    );
}
